import * as t from 'io-ts';

import {
  defaultLastWriterWinsValue,
  mergeLastWriterWinsValue,
  RLastWriterWinsValue,
} from './lastWriterWinsValue';

/*
 * Runtime types.
 */

export const RUserSurveySubmissionHistory = t.intersection([
  RLastWriterWinsValue,
  t.type({
    surveySubmissions: t.record(t.string, t.type({didSubmit: t.boolean, timestamp: t.number})),
  }),
]);

export type UserSurveySubmissionHistory = t.TypeOf<typeof RUserSurveySubmissionHistory>;

export const defaultUserSurveySubmissionHistory: UserSurveySubmissionHistory = {
  ...defaultLastWriterWinsValue,
  surveySubmissions: {},
};

/*
 * Conflict resolution.
 */

export const mergeUserSurveySubmissionHistory: (
  left: UserSurveySubmissionHistory,
  right: UserSurveySubmissionHistory,
) => UserSurveySubmissionHistory = mergeLastWriterWinsValue;
